import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { MEDIUM_SOY } from 'bento-ordering/base/constants/colors';
import VariantFieldSet from 'bento-ordering/base/components/VariantFieldSet';

const styles = theme => ({
  checked: {
    '& .$MuiSvgIcon-root': {
      fill: MEDIUM_SOY
    }
  },
  container: {
    display: 'flex'
  },
  text: {
    flexGrow: 1,
    lineHeight: '42px',
    textAlign: 'right'
  }
});

class RadioButtonGroup extends React.Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    title: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.shape({}),
    required: PropTypes.bool,
    selectionSatisfied: PropTypes.bool,
    classes: PropTypes.object,
    helperText: PropTypes.string
  };

  /**
   * returns `inputProps` for the Radio component
   */
  getRadioInputProps = () => {
    const { required } = this.props;
    const inputProps = {};

    if (required) {
      inputProps['aria-required'] = true;
    }

    return inputProps;
  };

  renderRadioGroup = () => {
    const { list, classes } = this.props;
    const {
      container: containerClass,
      text: textClass,
      ...radioClasses
    } = classes;
    if (list) {
      return list.map((item, index) => {
        const { label, value, price } = item;
        return (
          <Grid container key={index} className={containerClass}>
            <Grid item>
              <FormControlLabel
                value={value}
                control={
                  <Radio
                    inputProps={this.getRadioInputProps()}
                    classes={radioClasses}
                  />
                }
                label={label}
                key={index}
              />
            </Grid>
            <Grid item className={textClass}>
              <Typography component="span" key={index}>
                {price ? `+$${price}` : ' '}
              </Typography>
            </Grid>
          </Grid>
        );
      });
    }
  };

  render() {
    const {
      title,
      onChange,
      value,
      required,
      selectionSatisfied,
      helperText
    } = this.props;
    return (
      <VariantFieldSet
        title={title}
        required={required}
        selectionSatisfied={selectionSatisfied}
        helperText={helperText}
      >
        <Grid container>
          <RadioGroup
            aria-label={title}
            name={title}
            value={value}
            onChange={onChange}
          >
            <Grid container>{this.renderRadioGroup()}</Grid>
          </RadioGroup>
        </Grid>
      </VariantFieldSet>
    );
  }
}

export default withStyles(styles)(RadioButtonGroup);
